import React, { useEffect, useState } from "react";
import "./congratulationsInfo.scss";
import MainTitle from "../command/mainTitle/mainTitle";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Info, MapPin } from "react-feather";
import {
  CollectStore,
  DeliveryTruck,
  Effect,
} from "../../assets/svgIcon/customIcon";
import {
  AppStore,
  Checkmark,
  CongratCalendar,
  PlayStore,
  SparkleSvg,
} from "../../assets/svgImages/svgImages";
import moment from "moment";
import { calculateDuration, isSameDate } from "../../utils/utils";
import {
  AUTH_CRED,
  QUOTE_SESSION,
  deleteCookie,
  getAuthCredentials,
} from "../../utils/auth-utils";
import LoaderPage from "../command/loader/loader";
import { useTranslation } from "react-i18next";
import { productDetailsClient } from "../../data/product-details";
import { toast } from "react-toastify";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
const { quoteId } = getAuthCredentials();

const CongratulationsInfo = () => {
  const [data, setData] = useState<any>([]);
  const [quoteData, setQuoteData] = useState<any>();
  const [loading, setLoading] = useState<boolean>(true);
  const [callCount, setCallCount] = useState(0);
  const [stopCall, setStopCall] = useState(false);
  const [deliveryType, setDelivryType] = useState<string>("inStore");
  const { t } = useTranslation();
  const location = useLocation();

  const [orderReferenceId, setOrderReferenceId] = useState(null);
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  const status = params.get("status");
  const quoteIdFromURL = params.get("orderId");
  const transactionId = params.get("transactionId");

  useEffect(() => localStorage.removeItem("journeyID"), []);

  useEffect(() => {
    // if (status === 'tds_failed' || status === 'tds_expired') {
    //   navigate("/payment?status=failure");
    // }
    if (status !== "success") {
      toast.error("Something went wrong.");
      setLoading(false);
      navigate("/rental-summary");
    }
  }, [status]);

  const getQuoteData = async () => {
    await productDetailsClient
      .getProductDetailsList({
        quoteUuid: quoteIdFromURL,
      })
      .then((data: any) => {
        setDelivryType(data?.quote?.deliveryMethod);
        setData(data.products);
        setQuoteData(data.quote);
        setOrderReferenceId(data.quote?.orderReferenceId);
if (data.quote?.orderReferenceId && data?.quote?.isDeleted) {
          setStopCall(true);
          deleteCookie(QUOTE_SESSION);
          deleteCookie(AUTH_CRED);
          setLoading(false);
          localStorage.clear();
        }
        setLoading(false);
      })
      .catch((error: any) => {
        toast.error(error?.message);
        setStopCall(true);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (
      // quoteId != null &&
      quoteIdFromURL
      // quoteId == quoteIdFromURL
    ) {
      const interval = setInterval(() => {
        if (stopCall || callCount >= 3) {
          clearInterval(interval);
        } else {
          getQuoteData();
          setCallCount((prevCount) => prevCount + 1);
        }
      }, 2000);
      return () => clearInterval(interval);
    } else {
      navigate("/not-found");
    }
  }, [quoteIdFromURL, callCount, stopCall]);

  if (loading) {
    return <LoaderPage />;
  }
  const formatYear = (dateString: string) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    return year ? `${year}` : "";
  };

  function formatDate(dateString: string) {
    const date = new Date(dateString);
    const day = date.getUTCDate();
    const month = date.toLocaleString("default", {
      month: "short",
      timeZone: "UTC",
    });
    const year = date.getUTCFullYear();

    return (
      <h5>
        {day}
        <sup>{getOrdinalSuffix(day)}</sup> {month} {year}
      </h5>
    );
  }
  function getOrdinalSuffix(day: number) {
    if (day >= 11 && day <= 13) {
      return "th";
    }
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  }
  const formatTime = (isoString: any) => {
    const date = new Date(isoString);

    let hours = date.getUTCHours();
    const minutes = date.getUTCMinutes().toString().padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";

    // Convert hours from 24-hour format to 12-hour format
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'

    return `${hours}:${minutes} ${ampm}`;
  };

  return (
    <>
      {!quoteData?.isForPurchase && (
        <section className="congratulations-info section-space">
          <div className="container">
            <div className="offset-lg-2 col-lg-8">
              <div className="effect-add-section">
                <Effect className="effect-img" />
                <div className="congratulations-box">
                  {quoteData?.canConvertedToPurchaseAfterRent ? (
                    <MainTitle
                      mainText={t("your-trial-booked")}
                      className="congrats-title"
                    />
                  ) : (
                    <MainTitle
                      mainText={t("your-rental-booked")}
                      className="congrats-title"
                    />
                  )}
                  {!quoteData?.isCreatedByRetailer && (
                    <div className="congrats-img-box">
                      <SparkleSvg className="sparkle" />
                      <CongratCalendar className="congrats-calendar" />
                      <Checkmark className="checkmark" />
                      <h5 className="calendar-year">
                        {formatYear(data[0]?.productBookingStartDate)}
                      </h5>
                    </div>
                  )}

                  {orderReferenceId ? (
                    <p className="order-reference">
                      Order Reference Id : <span>{orderReferenceId}</span>
                    </p>
                  ) : (
                    <p className="order-reference">
                      Your order is in processing state we will update you shortly
                      via email and SMS.
                    </p>
                  )}

                  {!quoteData?.isCreatedByRetailer && <>
                    {isSameDate(
                      quoteData?.quoteScheduleDate,
                      quoteData?.quoteEndDate
                    ) && quoteData?.rentalType == 'hourly' ? (
                      <div className="congrats-selected-date hourly-date-selected">
                        <div className="hourly-date">
                          {formatDate(quoteData?.quoteScheduleDate)}
                        </div>
                        <div className="date-selected">
                          <div className="g-date">
                            <h5>{formatTime(quoteData?.quoteScheduleDate)}</h5>
                          </div>
                          <div className="date-duration">
                            <h6>
                              {calculateDuration(
                                quoteData?.quoteScheduleDate,
                                quoteData?.quoteEndDate,
                                quoteData?.rentalType,
                                quoteData?.rentalDuration
                              )}
                            </h6>
                          </div>
                          <div className="g-date">
                            <h5>{formatTime(quoteData?.quoteEndDate)}</h5>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="congrats-selected-date">
                        <div className="date-selected">
                          <div className="g-date">
                            {formatDate(quoteData?.quoteScheduleDate)}
                          </div>
                          <div className="date-duration">
                            <h6>
                              {quoteData?.rentalType === 'monthly-recurring' ? t('monthly-rolling') : data[0]?.rentalTerm}{" "}
                              {quoteData?.rentalType === 'monthly' ? data[0]?.rentalTerm > 1 ? t("months") : t("month") : ''}
                              {quoteData?.rentalType === 'daily' ? data[0]?.rentalTerm > 1 ? t("days") : t("day") : ''}
                            </h6>
                          </div>
                          <div className="g-date">
                            {quoteData?.rentalType === 'monthly-recurring' ? t("flexible") : formatDate(quoteData?.quoteEndDate)}
                          </div>
                        </div>
                      </div>
                    )}

                    {quoteData?.rentalType === 'monthly-recurring' &&
                      <span className="mb-2 d-block fw-medium text-center" >
                        Rental agreements will roll into a month-by-month
                        agreement until the item is returned or
                        for a maximum of 12 consecutive
                        monthly terms.
                      </span>
                    }
                  </>}
                  {/* )
                )} */}
                  {/* Group products by productUuid and productVariantUuid */}
                  <div className="multi-product-section">
                    {data?.map((item: any, index: number) => (
                      <div className="multi-product-box" key={index}>
                        <h3 className="product-name ascasc">
                          {item.productQuantity || 1} × {item.productName}
                          {(item.option1 || item.option2 || item.option3) && (
                            <div className="variant-options">
                              <p className="variant-option">
                                {item.option1 && (
                                  <span className="option">
                                    {item.option1.includes(': ')
                                      ? <><span className="option-label">{item.option1.split(': ')[0]}: </span>{item.option1.split(': ')[1]}</>
                                      : item.option1}
                                  </span>
                                )}
                                {item.option2 && (
                                  <span className="option">
                                    {item.option2.includes(': ')
                                      ? <><span className="option-label">{item.option2.split(': ')[0]}: </span>{item.option2.split(': ')[1]}</>
                                      : item.option2}
                                  </span>
                                )}
                                {item.option3 && (
                                  <span className="option">
                                    {item.option3.includes(': ')
                                      ? <><span className="option-label">{item.option3.split(': ')[0]}: </span>{item.option3.split(': ')[1]}</>
                                      : item.option3}
                                  </span>
                                )}
                              </p>
                            </div>
                          )}
                        </h3>
                      </div>
                    ))}
                  </div>
                  {/* For Single Product */}
                  {/* <h3 className='product-name'>DJI Mavic Pro Drone + Extra</h3> */}
                  {/* For Multiple Products */}
                  {/* <div className='multi-product-section'>
                  <div className='multi-product-box'>
                    <h3 className='product-name ascasc'>DJI Mavic Pro Drone + Extra</h3>
                  </div>
                  <div className='multi-product-box'>
                    <h3 className='product-name ascasc'>DJI Mavic Pro Drone + Extra</h3>
                  </div>
                  <div className='multi-product-box'>
                    <h3 className='product-name ascasc'>DJI Mavic Pro Drone + Extra</h3>
                  </div>
                  <div className='multi-product-box'>
                    <h3 className='product-name ascasc'>DJI Mavic Pro Drone + Extra</h3>
                  </div>
                </div> */}
                  <div className="congrats-content-box">
                    <div className="collect-details">
                      {data.map(
                        (item: any, index: number) =>
                          index === 0 && (
                            <>
                              {deliveryType === "Delivery and Collection" ? (
                                <>
                                  <DeliveryTruck className="collect-img delivery-t" />
                                  <h4>
                                    {t("delivery-your-product")}{" "}
                                    {formatDate(item.productBookingStartDate)}
                                  </h4>
                                </>
                              ) : (
                                <>
                                  <CollectStore className="collect-img" />
                                  <h4>
                                    {t("you-can-collect")}{" "}
                                    {formatDate(item.productBookingStartDate)}
                                  </h4>
                                </>
                              )}
                            </>
                          )
                      )}
                    </div>
                    {/* {deliveryType === "inStore" && (
                    <Link to={"#"} className="site-link map-pin-link">
                      <MapPin /> {t("store-location")}
                    </Link>
                  )} */}
                  </div>
                  {!quoteData?.isCreatedByRetailer && (
                    <>
                      <hr className="congrats-seperater"></hr>

                      {quoteData?.ownItPricing && (
                        <div className="ownit-congrats">
                          <h4 className='ownit-popup-title text-center'>
                            {t('Try it, love it.')} <span className='ownit-text-blackgreen'>OWN<span>it.</span></span>
                          </h4>
                          <p className="text-center">{t('Try-before-you-buy.')}</p>
                          <div className="ownit-box d-flex align-items-center justify-content-between mt-3">
                            <div>
                              <div className="ownit-text-black">OWN<span>it</span></div>
                              <label
                                htmlFor="optional-price-after-trial"
                                className="form-check-label"
                              >
                                {t("optional-price-after-trial")}
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip id={`tooltip-op`}>
                                      <div dangerouslySetInnerHTML={{ __html: t("optional-price-after-trial-tooltip") }} />
                                    </Tooltip>
                                  }
                                >
                                  <Info className="info-icon ms-2" size={18} />
                                </OverlayTrigger>
                              </label>
                            </div>
                            <div className="ownit-price-text text-end">
                              <div className="ownit-price">£{quoteData?.ownItPricing?.purchasePrice?.toFixed(2)}</div>
                              <div>
                                <span className="fw-bold">{quoteData?.ownItPricing?.discountPercentage}% off</span> retail price
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      <div className="store-app-section">
                        {!quoteData?.ownItPricing && (
                          <h3>{t("download-the-app-description")} Renticy App</h3>
                        )}
                        {quoteData?.ownItPricing && (
                          <h3>{t("download-the-app-ownit-description")} Renticy App</h3>
                        )}
                        <div className="d-flex justify-content-center">
                          <Link
                            target="_blank"
                            to={
                              "https://play.google.com/store/apps/details?id=com.renticy&hl=en"
                            }
                            className="play-store-link me-md-2 me-1"
                          >
                            <PlayStore className="play-store-svg" />
                          </Link>
                          <Link
                            target="_blank"
                            to={
                              "https://apps.apple.com/in/app/renticy/id6514299223?platform=ipad"
                            }
                            className="play-store-link ms-md-2 ms-1"
                          >
                            <AppStore className="play-store-svg" />
                          </Link>
                        </div>
                      </div>
                    </>
                  )}
                  {quoteData?.isCreatedByRetailer && (
                    <div className="back-to-admin-wrapper">
                      <a
                        href="https://retailer.renticy.co/products/inventory"
                        className="back-to-admin-btn"
                      >
                        Continue
                      </a>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {quoteData?.isForPurchase && (
        <section className="congratulations-info section-space">
          <div className="container">
            <div className="offset-lg-2 col-lg-8">
              <div className="effect-add-section">
                <Effect className="effect-img" />
                <div className="congratulations-box">
                  <MainTitle
                    mainText={t("Congratulations")}
                    className="congrats-title1"
                  />

                  <div className="congrats-img-box">
                    <SparkleSvg className="sparkle" />

                    <h4 className="ownit-popup-title text-center position-absolute top-50 translate-middle-y">You now <span className="ownit-text-blackgreen">OWN<span>it.</span></span></h4>
                  </div>

                  <div className="multi-product-section">
                    {data?.map((item: any, index: number) => (
                      <div className="multi-product-box" key={index}>
                        <h3 className="product-name ascasc">
                          {item.productQuantity || 1} × {item.productName}
                          {(item.option1 || item.option2 || item.option3) && (
                            <div className="variant-options">
                              <p className="variant-option">
                                {item.option1 && (
                                  <span className="option">
                                    {item.option1.includes(': ')
                                      ? <><span className="option-label">{item.option1.split(': ')[0]}: </span>{item.option1.split(': ')[1]}</>
                                      : item.option1}
                                  </span>
                                )}
                                {item.option2 && (
                                  <span className="option">
                                    {item.option2.includes(': ')
                                      ? <><span className="option-label">{item.option2.split(': ')[0]}: </span>{item.option2.split(': ')[1]}</>
                                      : item.option2}
                                  </span>
                                )}
                                {item.option3 && (
                                  <span className="option">
                                    {item.option3.includes(': ')
                                      ? <><span className="option-label">{item.option3.split(': ')[0]}: </span>{item.option3.split(': ')[1]}</>
                                      : item.option3}
                                  </span>
                                )}
                              </p>
                            </div>
                          )}
                        </h3>
                      </div>
                    ))}
                  </div>

                  <div className="text-center">
                    <div> Your payment of </div>
                    <div className="ownit-popup-title text-center">£{quoteData?.totalQuoteValue}</div>
                    <div>is completed and retailer has been notified. ​</div>
                  </div>

                  <div className="store-app-section">
                    <div className="d-flex justify-content-center">
                      <Link
                        target="_blank"
                        to={
                          "https://play.google.com/store/apps/details?id=com.renticy&hl=en"
                        }
                        className="play-store-link me-md-2 me-1"
                      >
                        <PlayStore className="play-store-svg" />
                      </Link>
                      <Link
                        target="_blank"
                        to={
                          "https://apps.apple.com/in/app/renticy/id6514299223?platform=ipad"
                        }
                        className="play-store-link ms-md-2 ms-1"
                      >
                        <AppStore className="play-store-svg" />
                      </Link>
                    </div>
                  </div>
                  {quoteData?.isCreatedByRetailer && (
                    <div className="back-to-admin-wrapper">
                      <a
                        href="https://retailer.renticy.co/products/inventory"
                        className="back-to-admin-btn"
                      >
                        Back to Store Admin
                      </a>
                    </div>
                  )}
                </div></div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default CongratulationsInfo;
